import { create } from "zustand";
import { devtools, persist, createJSONStorage } from "zustand/middleware";

function objectToBase64(object) {
  const json = JSON.stringify(object);
  return btoa(encodeURIComponent(json));
}

function base64ToObject(base64) {
  const json = decodeURIComponent(atob(base64));
  return JSON.parse(json);
}

// Custom storage object
const storage = {
  getItem: async (name) => {
    const base64 = localStorage.getItem(name);
    return base64 ? base64ToObject(base64) : null;
  },
  setItem: async (name, value) => {
    localStorage.setItem(name, objectToBase64(value));
  },
  removeItem: async (name) => {
    localStorage.removeItem(name);
  },
};

const persistMiddlewares = (f) => {
  return devtools(
    persist(f, {
      name: "commonNTTStore",
      onRehydrateStorage: () => (state) => {
        state.setHasHydrated(true);
        state.toggleShowNotificationPanel(false);
        state.toggleShowNotificationUnread(false);
      },
      storage: createJSONStorage(() => storage),
    })
  );
  // return f;
};

const useCommonStore = create()(
  persistMiddlewares((set, get) => ({
    anyNotificationUnread: false,
    showNotificationPanel: false,
    notificationData: null, // Store notification data from header

    serviceProviders: [],
    tenants: [],
    locations: [],
    cameras: [],
    spTypeLogin: "",
    // clear all state
    clearAllStore: () => {
      set((state) => ({
        serviceProviders: [],
        tenants: [],
        locations: [],
        cameras: [],
        spTypeLogin: "",
      }));
    },

    // update function
    setSpTypeLogin: (data) => {
      set((state) => ({
        ...state,
        spTypeLogin: data,
      }));
    },
    setServiceProviders: (data) => {
      set((state) => ({
        ...state,
        serviceProviders: data,
      }));
    },
    setTenants: (data) => {
      set((state) => ({
        ...state,
        tenants: data,
      }));
    },
    setLocations: (data) => {
      set((state) => ({
        ...state,
        locations: data,
      }));
    },
    setCameras: (data) => {
      set((state) => ({
        ...state,
        cameras: data,
      }));
    },
    // setNewCameras: (newData) => {
    //   set((state) => {
    //     console.log(state);
    //     return ({
    //       cameras: [...state, newData],
    //     })
    //   });
    // },
    toggleShowNotificationPanel: (isShow) => {
      set((state) => ({
        ...state,
        showNotificationPanel: isShow,
      }));
    },
    toggleShowNotificationUnread: (value) => {
      set((state) => ({
        ...state,
        anyNotificationUnread: value,
      }));
    },
    setNotificationData: (data) => {
      set((state) => ({
        ...state,
        notificationData: data,
      }));
    },
    // for setup
    _hasHydrated: false,
    setHasHydrated: (isLoad) => {
      set({
        _hasHydrated: isLoad,
      });
    },
  }))
);

export { useCommonStore };
